import { BaseEdge, EdgeLabelRenderer, type EdgeProps } from '@xyflow/react'

/** Self-transitions are business loops, not zero-length ordinary connections. */
export const WorkflowLoop = ({ id, sourceX, sourceY, targetX, targetY, label, style, selected }: EdgeProps) => {
  const loopX = Math.max(sourceX, targetX) + 190
  const centerY = (sourceY + targetY) / 2
  const path = `M ${sourceX} ${sourceY} C ${sourceX} ${sourceY + 55}, ${loopX} ${sourceY + 55}, ${loopX} ${centerY} C ${loopX} ${targetY - 55}, ${targetX} ${targetY - 55}, ${targetX} ${targetY}`
  const labelStyle = { transform: `translate(-50%, -100%) translate(${loopX - 35}px, ${targetY - 40}px)` }
  const edgeStyle = { ...style, strokeWidth: selected ? 3 : 2 }
  return <>
    <BaseEdge id={id} path={path} style={edgeStyle} />
    <EdgeLabelRenderer><div className="instance-administration__workflow-loop-label" style={labelStyle}>{label}</div></EdgeLabelRenderer>
  </>
}
